import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useBooleanState } from '@cian/react-utils';

import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useParallaxBetweenOffersParameters } from './hooks';

type TAdBannerMicrofrontendParallaxBetweenOffersContainerProps = {
  manifest: IMicrofrontendManifest;
  position: number;
};

/**
 * Параллакс-баннер между офферами листинга ЖК на микрофронтенде ad-banner-frontend.
 */
export const AdBannerMicrofrontendParallaxBetweenOffersContainer: React.FC<
  TAdBannerMicrofrontendParallaxBetweenOffersContainerProps
> = ({ manifest, position }) => {
  const { state: isHidden, setTrue: hide } = useBooleanState();
  const parameters = useParallaxBetweenOffersParameters(position);

  if (isHidden) {
    return null;
  }

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={hide}
      onError={hide}
      onClose={hide}
    />
  );
};
